/**
 * Canonical public URL for a team (/teams/{short_name}?season_id=).
 * Accepts either a team object or a flat player payload with team_* fields.
 *
 * Prefer team_url / short_name over generic `url` — player payloads also have
 * `url` pointing at the player profile.
 */
export function teamPublicPath(team, seasonId = undefined) {
    if (!team) {
        return null;
    }

    const resolvedSeasonId = seasonId ?? team.season_id ?? team.team_season_id ?? null;

    if (team.team_url) {
        return appendSeasonId(team.team_url, resolvedSeasonId);
    }

    const shortName = team.short_name || team.team_short_name || team.team_short;
    if (shortName) {
        return appendSeasonId(`/teams/${shortName}`, resolvedSeasonId);
    }

    if (typeof team.url === 'string' && team.url.includes('/teams/')) {
        return appendSeasonId(team.url, resolvedSeasonId);
    }

    return null;
}

function appendSeasonId(path, seasonId) {
    if (seasonId === null || seasonId === undefined || seasonId === '') {
        return path;
    }

    try {
        const url = new URL(path, 'http://local');
        if (!url.searchParams.has('season_id')) {
            url.searchParams.set('season_id', String(seasonId));
        }
        return `${url.pathname}${url.search}`;
    } catch {
        const sep = path.includes('?') ? '&' : '?';
        return `${path}${sep}season_id=${seasonId}`;
    }
}
